<template>
    <GetStartedLayout
        :errors="errors"
        title="Great!"
        subtitle="We'll hold this time while you checkout"
        :breadcrumbs="breadcrumbs"
        ref="layout"
        :guest="guest"
        :child="child"
        :review="review"
        :location="guest.location"
    >
        <v-col
            class="white--text text-center px-0"
            cols="12"
            sm="10"
            md="8"
            lg="6"
        >
            <v-card
                class="mx-auto"
                :tile="$vuetify.breakpoint.xs"
                :class="{ 'soli-round': $vuetify.breakpoint.smAndUp }"
            >
                <v-container
                    class="py-5"
                    :class="$vuetify.breakpoint.smAndUp ? 'px-5' : 'px-0'"
                >
                    <Lesson
                        :lesson="lesson"
                        :errors="errors"
                        :guest="guest"
                        :child="child" />
                    <Experience
                        v-if="false"
                        v-model="form.experience"
                        :lesson="lesson"
                        :guest="guest"
                        :errors="errors" />
                    <GetStartedPayment
                        ref="payment"
                        :key="paymentReset"
                        :guest="guest"
                        :child="child"
                        :location_id="lesson.room?.location_id"
                        :teacherName="lesson.teacher?.name"
                        :lesson="lesson"
                        :errors="errors"
                        @applyPromo="$refs.layout.showMessage = true"
                        @submit="submit($event)"
                /></v-container>
            </v-card>
        </v-col>
    </GetStartedLayout>
</template>

<script>
import Experience from "../../Components/GetStarted/Experience.vue";
import GetStartedPayment from "../../Components/GetStarted/GetStartedPayment.vue";
import Lesson from "../../Components/GetStarted/Lesson.vue";
import GetStartedLayout from "../../Layouts/GetStartedLayout.vue";
import { Link } from "@inertiajs/vue2";

export default {
    components: {
        GetStartedLayout,
        Link,
        GetStartedPayment,
        Lesson,
        Experience,
    },
    props: {
        errors: {},
        guest: {
            type: Object,
            default: () => {},
        },
        child: {
            type: Object,
            default: () => {},
        },
        lesson: {
            type: Object,
            default: () => {},
        },
        review: {
            type: Object,
            default: null,
        },
    },
    name: "Confirm",
    data: function () {
        return {
            breadcrumbs: this.guest.virtual_client
                ? ["Book Now", "Confirm"]
                : ["Get Started", "Programs", "Book Now", "Confirm"],
            loading: false,
            paymentReset: false,
            form: this.$inertia.form({
                lesson_id: this.lesson.id,
                //notes: form.experience,
            }),
            /*{
                experience: null,
            },*/
            /*selectedProgram: null,
            steps: [
                {
                    value: 1,
                    title: "Great! We'll hold this time while you create an account.",
                },
                {
                    value: 2,
                    upperTitle: "Amazing!",
                    title: `We've sent an email to ${this.email} with next steps`,
                    signature: "Happy music-making!",
                },
            ],
            stepNumber: 1,*/
        };
    },
    methods: {
        submit(paymentInfo) {
            this.form
                .transform((form) => ({
                    ...form,
                    payment: paymentInfo.payment,
                    priceId: paymentInfo.priceId,
                    promoId: paymentInfo.promoId,
                    giftId: paymentInfo.giftId,
                }))
                .post(route("getStarted.storeAccount", this.child?.hash_id), {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {},
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                        this.paymentReset = !this.paymentReset;
                        if (errors.contactSupport) return;
                        if (errors.soliError) return;
                    },
                });
        },
    },
};
</script>

<style scoped></style>
